import { useEffect, useState } from "react"

export default function useDidAttempt({transcript}){

    const [ cachedTranscript ] = useState(transcript)
    const [ didAttempt, setDidAttempt ] = useState(false)

    useEffect(()=>{
        console.log("useDidAttempt", transcript, cachedTranscript)

        if(transcript.interim || cachedTranscript.interim || transcript.final || cachedTranscript.final){
            if(transcript.interim !== cachedTranscript.interim || transcript.final !== cachedTranscript.final){
                setDidAttempt(true)
            }
        }
    }, [transcript.interim, transcript.final, cachedTranscript.interim, cachedTranscript.final])

    return {
        didAttempt: didAttempt
    }
}